import Vue from 'vue'

export const DialogModalBus = new Vue()